// src/components/utils/storage.js

// ----------- LOAD DATA -----------
export const loadNewsData = () => {
  try {
    const stored = localStorage.getItem("newsData");

    if (stored) {
      return JSON.parse(stored);
    }

    // Fallback to bundled JSON file
    const defaultData = require("../../locales/newsData.json");
    return defaultData;

  } catch (e) {
    console.error("loadNewsData error:", e);
    return require("../../locales/newsData.json");
  }
};

// ----------- SAVE DATA -----------
export const saveNewsData = (data) => {
  try {
    localStorage.setItem("newsData", JSON.stringify(data));
  } catch (e) {
    console.error("saveNewsData error:", e);
  }
};

// -------------------------------------------------
// DELETE POST
// category: "news" | "insights" | "popular"
// language: "en" | "ar"
// -------------------------------------------------
export const deletePost = (id, category, language = "en") => {
  try {
    let db = loadNewsData();

    if (!db[language] || !db[language][category]) return db;

    db[language][category] = db[language][category].filter(
      (item) => item.id !== id
    );

    saveNewsData(db);
    return db;

  } catch (e) {
    console.error("deletePost error:", e);
    return loadNewsData();
  }
};

// -------------------------------------------------
// UPSERT POST (add or update)
// category: "news" | "insights" | "popular"
// language: "en" | "ar"
// -------------------------------------------------
export const upsertPost = (post, category, language = "en") => {
  try {
    let db = loadNewsData();

    // ensure category exists
    if (!db[language][category]) {
      db[language][category] = [];
    }

    // update or insert
    const exists = db[language][category].find((p) => p.id === post.id);

    if (exists) {
      db[language][category] = db[language][category].map((p) =>
        p.id === post.id ? post : p
      );
    } else {
      db[language][category].unshift(post); // add newest first
    }

    saveNewsData(db);
    return db;

  } catch (e) {
    console.error("upsertPost error:", e);
    return loadNewsData();
  }
};
